var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal modals-share-your-design",
      "height": "auto",
      "name": "shareYourDesign",
      "width": "90%",
      "clickToClose": true
    },
    on: {
      "beforeOpen": _vm.beforeOpen,
      "beforeClose": _vm.beforeClose
    }
  }, [_c('CustomContainer', {
    class: ['new-modal-wrapper', 'customs-tools', {
      'new-modal-wrapper__modify': !_vm.hideConfirmationModal
    }],
    attrs: {
      "elementType": "section"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "id": "snapshot-image-scene"
    }
  }), _c('ModalHeader', {
    attrs: {
      "headerImg": false
    },
    on: {
      "closeEvent": _vm.closeModal
    }
  }), _c('ShareYourDesignForm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hideConfirmationModal,
      expression: "hideConfirmationModal"
    }],
    attrs: {
      "enable-check": _vm.enableCheck
    },
    on: {
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton,
      "showHideConfirmationModal": _vm.showHideConfirmationModal
    }
  }), _c('ConfirmationShareYourDesign', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hideConfirmationModal,
      expression: "!hideConfirmationModal"
    }]
  }), _c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hideConfirmationModal,
      expression: "hideConfirmationModal"
    }],
    staticClass: "new-modal-button-nav"
  }, [_c('CustomContainer', {
    staticClass: "new-modal-button-nav-container"
  }, [_c('CustomButton', {
    attrs: {
      "form": "share-form",
      "customClass": "new-modal-button-nav-container-cta expanded",
      "isDisabled": _vm.disableSendButton,
      "keyTranslation": "shareYourDesignSend",
      "type": "submit"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }